import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=30d8fd0d&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"
import style0 from "./Menu.vue?vue&type=style&index=0&id=30d8fd0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d8fd0d",
  null
  
)

export default component.exports